import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { HttpService } from '../../../services/http.service';
import { UserAccountDTO } from '../../../classes/user-account.dto';
import { StorageService } from '../../../services/storage.service';
import { Subscription } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { FeedbackModalComponent } from '../../feedback-modal/feedback-modal/feedback-modal.component';
import { GtmService } from '../../../services/gtm.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule, NzDividerModule, TranslateModule, NzModalModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationsComponent implements OnInit {
  data: any;
  pageIndex: number = 25;
  pageSize: number = 0;
  isLoading = false;
  noMoreData = false;
  notificationSub?: Subscription;
  dossierCode?: string;
  nAppointment?: number;
  contactId?: string;

  constructor(
    private http: HttpService,
    private storage: StorageService,
    private modal: NzModalService,
    private modalRef: NzModalRef<NotificationsComponent>,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
    this.gtmService.pushVirtualPage('Notifications View', '/notifications_view')
    AppComponent.onNotification.subscribe(() => {
     this.loadNotifications();
   });
  }

loadNotifications(): void {
 const individualId = this.getIndividualId();
 this.http.getNotifications(individualId, this.pageIndex, this.pageSize).subscribe((response) => {
   this.data = response;
   const matchingNotification = this.data.find((n: any) =>
     n.serviceType === 'TelevisitVideoConsultCompleted'
   );
   if (matchingNotification) {
       const firstParse = JSON.parse(matchingNotification.callToActionJSON);
       const callToAction = JSON.parse(firstParse);
       this.dossierCode = callToAction.dossierCode;
       this.nAppointment = Number(callToAction.nAppointment);
       this.contactId = callToAction.contactId;
      }
 });
}

  getIndividualId(): string {
    const user = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    return user.individualId;
  }

  markAsRead(notification: any): void {
    if (notification.toRead) {
      notification.callToActionJSON = '';
      this.http.markAsRead(notification).subscribe({
        next: (updatedNotification) => {
          const index = this.data.findIndex((n: any) => n.id === updatedNotification.id);
          if (index !== -1) {
            this.data[index] = { ...this.data[index], ...updatedNotification };
          }
          console.log(`Notification ${updatedNotification.id} marked as read.`);
        },
        error: (error) => {
          console.error(`Error marking notification ${notification.id} as read:`, error);
        },
      });
    }
  }

  markAllAsRead(): void {
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData.individualId;
    this.http.markAllAsRead(individualId).subscribe({
      next: () => {
        this.data = this.data.map((notification: any) => ({
          ...notification,
          toRead: false,
        }));
        console.log('All notifications marked as read.');
      },
      error: (error) => {
        console.error('Error marking all notifications as read:', error);
      },
    });
  }

  checkLinkValidity(notification: any): boolean {
    if (notification.callToActionJSON) {
      if (notification.serviceType === 'VideoConsultReadyTelevisitVideo' || notification.serviceType === 'VideoConsultReady') {
        const link = JSON.parse(notification.callToActionJSON);
        if (!link) {
          return false;
        }
        return link.roomUrl === null ? false : JSON.parse(link)?.roomUrl ? true : false;
      } else if (notification.serviceType === 'TelevisitVideoConsultCompleted') {
        return true;
      }
    }
    return false;
  }

  openLink(notification: any): void {
    if (notification.callToActionJSON) {
      this.gtmService.pushStartConsultation(notification.serviceType)
      if (notification.serviceType === 'VideoConsultReadyTelevisitVideo' || notification.serviceType === 'VideoConsultReady') {
        const link = JSON.parse(JSON.parse(notification.callToActionJSON))?.roomUrl;
        window.open(link, '_blank', 'noopener');
      } else if (notification.serviceType === 'TelevisitVideoConsultCompleted') {
        this.openModal();
      }
    }
  }


  public openModal(): void {
  this.modalRef.close();
  this.modal.create({
      nzContent: FeedbackModalComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dossierCode: this.dossierCode,
        nAppointment: this.nAppointment,
        contactId: this.contactId
      },
    });
    this.modalRef.afterClose.subscribe((result): void => {
      console.log(result);
    });
  }

  deleteNotification(notification: any): void {
    const id = notification.id;
    this.http.deleteNotification(id).subscribe({
      next: () => {
        this.data = this.data.filter((n: any) => n.id !== id);
      },
    });
  }

  ngOnDestroy(): void {
    AppComponent.onNotification.unsubscribe(); 
  }
}
